import { useState, useEffect, useReducer } from 'react';
import CanvasComponent from '../Canvas/canvas';
import NewFormComponent from '../NewForm/newform';
import TextControls from '../TextControls/textcontrols';
//import ToggleContainer from '../ToggleContainer/togglecontainer';
import FilePicker from '../FilePicker/filepicker';
import MenuItem from '../MenuItem/menuitem';
import FileViewer from '../FileViewer/fileviewer';

// Images
import ButtonUp from '../../img/btn_up.svg';
import ButtonText from '../../img/btn_text.svg';
import ButtonDown from '../../img/btn_down.svg';
import ButtonHelp from '../../img/btn_help.svg';
import Logo from '../../img/logo.svg';

// Styles
import './App.css';
import './AppFonts.css';
import HelpComponent from '../Help/help';
//import { InfoBlock } from '../InfoBlock/infoblock';

/** Reducer function to manage the state of content.
  * @param {Object} state - The current state of the content.
    @param {Object} state.text_objs - A list of the text objects that almost every component uses
    @param {Object} state.curr_id - counts text_obj elements (for thier id)
    
    @param {Object} action - The action to be processed by the reducer.
    @param {Object} action.type - This must contain the type in the switch.
  * 
    @returns {Object} The new state of the content after processing the action.
 */
function contentReducer(state, action){  
  switch (action.type){
    case 'INIT':
      return {
        curr_id: 0,
        text_objs: { /* "0": {...inititalContent,  id: 0} */ }
      };
    case 'SET_IMAGE':
      const { fileName, size, type, origin, width, height } = action.payload;
      return { ...state,
        fileName: fileName,
        width: width,
        height: height,
        size: size,
        type: type,
        origin: origin
      };
    case 'UPDATE_CONTENT':
      const { id, name, value } = action.payload;
      let clone_objs = {...state.text_objs};
      let clone = clone_objs[id];
      clone[name] = isNaN(value) ? value : Number(value);
      return { ...state,
        text_objs: clone_objs
      };  
    case 'ADD_CONTENT':
      let current_list = {...state.text_objs};
      let new_id = state.curr_id + 1;
      current_list[new_id] = {...action.payload, id: Number(new_id)};
      return { ...state,
        curr_id: new_id,
        text_objs: current_list 
      };
    case 'DELETE_CONTENT':
      const { ID } = action.payload;
      let temp_list = {...state.text_objs};
      delete temp_list[ID];
      return { ...state,
        text_objs: temp_list 
      };

    default:
      console.error(`Action not found: ${action.type}`);
      return state;
  }
}

function App() {
  // Init
  const [backgroundB64, setBackgroundB64] = useState(null);
  const [renderAllTrigger, setRenderAllTrigger] = useState(null);
  const [activeTxtID, setActiveTxtID] = useState(null);
  const [activeMenuID, setActiveMenuID] = useState(null);
  const [showHelp, setShowHelp] = useState(false);

  const [content, dispatchContent] = useReducer( contentReducer, {});
  useEffect(()=>{
    dispatchContent({ type: 'INIT'});
  }, []);

  function newFormHandler( form ){
    const img_width = Number(content.width);
    const img_height = Number(content.height);
    const user_position = form.get('position');
    const user_text = form.get('usertext');        
    const est_txt_height = (user_text.split('\n').length + 1) * 15;
    let rect = { x:0, y:0, w:img_width, h:est_txt_height };   
    switch( user_position ){
      case 'top': break;
      case 'middle':
        let m = img_height / 2;
        rect.y = Number( m - (rect.h/2));
      break;
      case 'bottom':
        rect.y = Number(img_height - rect.h)
      break;
      default:
        throw Error(`Cannot find position: ${user_position}`);
        //break;
    }

    let data = {
      font: form.get('font'),
      txtColor: form.get('txt_color'),
      strokeColor: form.get('stroke_color'),
      text: user_text,
      align: form.get('align'),
      vAlign: form.get('vAlign'),
      x: rect.x, 
      y: rect.y,
      height: rect.h, 
      width: rect.w,
      fontSize: 30
    }
    //console.log(JSON.stringify(data))
    dispatchContent({ type:"ADD_CONTENT", payload:data });
    handleMenuSelect(null); // deselect open menu
  }

  function contentUpdateHandler( data ){
    dispatchContent({ type:"UPDATE_CONTENT", payload:data });
    if (renderAllTrigger) setRenderAllTrigger(false);
    //const last_text = content.text_objs[content.curr_id];
  }

  function contentDeleteHandler( id ){
    dispatchContent({ type:"DELETE_CONTENT", payload:{ ID: id } });
  }

  function handleImageSelect( data ){
    if (!data) return;
    setBackgroundB64(data.content);
    dispatchContent({ type:"SET_IMAGE", payload:data });
    handleMenuSelect(null); // deselect open menu
  }

  function handleMenuSelect( id ){
    setActiveMenuID( id );
  }

  return (
    <>
    <div className="main-container">      
      <div className='tools-container flex-row plastic'>
        <img alt='meme-o-matic logo' className='tools-logo' src={Logo}></img>

        <MenuItem 
          ID='set-image' 
          activeID={activeMenuID} 
          onActivate={handleMenuSelect} 
          buttonImage={ButtonUp}
          disabled={false}
        >
          <FilePicker onFileSelect={handleImageSelect}/>
        </MenuItem>

        <MenuItem 
          ID='add-text' 
          activeID={activeMenuID} 
          onActivate={handleMenuSelect} 
          buttonImage={ButtonText}
          disabled={backgroundB64==null}
        >
          <NewFormComponent onSubmit={newFormHandler}/>
        </MenuItem>

        <MenuItem 
          ID='download-meme' 
          activeID={activeMenuID} 
          onActivate={handleMenuSelect} 
          buttonImage={ButtonDown}
          disabled={backgroundB64==null}
        >
          <div className='form-list'>
            <div className='title-container'>
              <h4>Download Image</h4>
              <small>Click to download this image back to your device.</small>
            </div>
            {<button onClick={()=>{ setRenderAllTrigger( true ) }}>Download</button>}
          </div>          
        </MenuItem>

        <MenuItem
          ID='help' 
          activeID={activeMenuID} 
          onActivate={handleMenuSelect} 
          buttonImage={ButtonHelp}
          disabled={false}          
        >
          <div className='form-list'>
            <div className='title-container'>
              <h4>Help</h4>
              <small>How to use the Meme O Matic</small>
            </div>
            <HelpComponent />
          </div>       
        </MenuItem>
        
      </div>

      <div className='details-container plastic'>        
        
        <TextControls
          content={content}        
          onSetID={ id => setActiveTxtID(id) } 
          onContentUpdate={contentUpdateHandler}
          onContentDelete={contentDeleteHandler}
        />
        
        { backgroundB64 ?
        (<FileViewer background={backgroundB64} content={content}/>) :
        (<div className='title-container'>
          <h4>No Image Loaded</h4>
          <small>Please choose an image</small>
        </div>) }
      </div>
      
      <div className='canvas-container'>

        <div className='power-inset'></div>

         <CanvasComponent
            renderAllTrigger={renderAllTrigger}
            activeID={activeTxtID}
            background={backgroundB64} 
            content={content}
          />
      </div>
    </div>

  </>);
}

export default App;